import { Form, Modal } from 'react-bootstrap'
import Delete_check_lottie from '../../../Animation/delete_check_lottie/Delete_check_lottie';

const Delete_Modal = (props) => {

    setTimeout(() => {
        props?.onHide()
    }, 5000);

    return (
        <Modal className="Success_Modal" size='sm' {...props} centered>

            <div className='absolute_div'>
                <div className='animation_holder'>
                    <Delete_check_lottie />
                </div>
            </div>

            <Modal.Body>
                <p className='success_text'>{props?.successText}</p>
            </Modal.Body>


        </Modal>
    )
}

export default Delete_Modal
